import React, { Component } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import {AuthActions} from "../../redux/reducers/Auth";
import { AccountInfo } from '@azure/msal-browser';

/* eslint import/no-webpack-loader-syntax: off */
import SignInWithMicrosoftLight from "!file-loader!../../images/sign_in_with_microsoft_light.svg"
import CDBLogoStandard from "!file-loader!../../images/cdb_logo_standard.svg";

interface SignInPageProps {
    user?: AccountInfo;
    prompt: string;
    thenRedirectTo?: string;
}

class SignInPage extends Component<SignInPageProps & DispatchProps ,any> {
    static displayName = SignInPage.name;

    constructor(props: SignInPageProps & DispatchProps) {
        super(props);

        this.state = {

        }
    }

    async componentDidMount() {
    }

    render () {
        return (
            <div className="cdb-sign-in-page">
                <img src={CDBLogoStandard}/>

                <p>{this.props.prompt}</p>

                <img className={"clickable"} src={SignInWithMicrosoftLight} onClick={() => {
                    this.props.dispatch(AuthActions.signIn(this.props.thenRedirectTo));
                }}/>

            </div>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {prompt: string, thenRedirectTo?: string}): SignInPageProps => {
        return {
            prompt: ownProps.prompt,
            thenRedirectTo: ownProps.thenRedirectTo
        };
    }
)(SignInPage)